/**
 * 客户回款，银行登记单 新增页面 表单配置处理
 * @author zjs
 * @time 2017-10-25
 */
export default {
    data () {
        return {
            // 表单组件配置
            formConfig: [{
                name: "登记起始日期",
                type: "LyDatePicker",
                field: "work_time",
                json: {
                    type: 'date'
                },
                default: ""
            },{
                name: "登记人",
                type: "ElInput",
                field: "clerk",
                json: {
                    disabled: true
                },
                default: ""
            },{
                name: "导入排序方式",
                type: "LySelect",
                field: "sort",
                json: {
                    all: false,
                    data: [{
                        value: '1',
                        label: '正序'
                    }, {
                        value: '2',
                        label: '倒序'
                    }]
                },
                default: "1"
            }, {
                name: "银行账户名称",
                type: "LyAutoSearch",
                field: "account",
                width: '220px',
                json: {
                    width: '301px',
                    api: 'api/shoukuanzh?tag_type=bank',
                    prop: 'label',
                    fields: [{
                        label: '收款账户',
                        prop: 'label',
                        width: 150
                    },{
                        label: '银行账号',
                        prop: 'account_number',
                        width: 150
                    }]
                },
                default: {}
            },{
                name: "银行账号",
                type: "LyAutoSearch",
                field: "account",
                width: '220px',
                json: {
                    width: '271px',
                    api: 'api/shoukuanzh?tag_type=bank',
                    prop: 'account_number',
                    fields: [{
                        label: '收款账户',
                        prop: 'label',
                        width: 150
                    },{
                        label: '银行账号',
                        prop: 'account_number',
                        width: 150
                    }]
                },
                default: {}
            },{
                name: "选择银行类型",
                type: "LySelect",
                field: "account_type",
                json: {
                    all: false,
                    api: 'api/bankseries'
                },
                default: ""
            }]
        }
    }
}